/* eslint-disable react/prop-types */

import React from 'react';
import { graphql } from 'gatsby';
import { useCookie } from 'react-use';
import PageMeta from '../components/PageMeta';
import Page from '../components/Page';
import TextHero from '../components/TextHero';
import FormSection from '../components/FormSection';

const ContactUsPage = ({ data }) => {
  const {
    contentfulContactUsPage: { pageMeta, form, hero },
  } = data;

  const COOKIE_NAME = 'PWC_RM_USER_GATE';
  const COOKIE_VALUE_UNGATED = '1';
  // eslint-disable-next-line no-unused-vars
  const [value, updateCookie, deleteCookie] = useCookie(COOKIE_NAME);

  const handleFormSubmit = () => {
    updateCookie(COOKIE_VALUE_UNGATED);
  };

  return (
    <Page>
      <PageMeta {...pageMeta} />
      <TextHero {...hero} />
      <FormSection
        form={form}
        onSubmit={() => {
          handleFormSubmit();
        }}
      />
    </Page>
  );
};

export default ContactUsPage;

export const query = graphql`
  query ContactUsPageQuery {
    contentfulContactUsPage(slug: {eq: "contact-us-default"}) {
      pageMeta {
        ...PageMeta
      }
      hero {
        ...TextHero
      }
      form {
        ...Form
      }
    }
  }
`;
